import {Injectable} from '@angular/core';
import {Platform} from '@uofu-uss-aux/software-catalog-ng-core';

export enum KnownPlatform {
  windows = 'windows',
  apple = 'apple',
  linux = 'linux',
  web = 'web'
}

@Injectable({
  providedIn: 'root'
})
export class PlatformService {

  private platforms = [
    {
      titles: ['OSX', 'Mac'],
      platform: KnownPlatform.apple,
    },
    {
      titles: ['Windows'],
      platform: KnownPlatform.windows,
    },
    {
      titles: ['Linux'],
      platform: KnownPlatform.linux,
    },
  ];

  constructor() {
  }

  findPlatform(platform: Platform): KnownPlatform {
    const found = this.platforms.find(obj => {
      return obj.titles.map(title => title.toLowerCase()).includes(platform?.title?.toLowerCase());
    });
    return found ? found.platform : KnownPlatform.web;
  }

}
